module.exports = __webpack_public_path__ + "img/HWQT.77604fe3.gif";